import { SelectInput } from '../../../SearchHub/SelectInput';

import { RecallsSearchTypeSelectWrapper } from './components';

import type { VehicleFormData } from '../../../SearchHub/Vehicle/utils';
import type { SxProps, Theme } from '@ltvco/refresh-lib/theme';
import type { Control } from '@ltvco/refresh-lib/vendors';

interface RecallsSearchTypeSelectProps {
  options: { value: string; label: string }[];
  value: string;
  onSearchTypeChange: (value: string) => void;
  control: Control<VehicleFormData>;
  wrapperSx?: SxProps<Theme>;
}

export function RecallsSearchTypeSelect({
  options,
  value,
  onSearchTypeChange,
  control,
  wrapperSx,
}: RecallsSearchTypeSelectProps) {
  return (
    <RecallsSearchTypeSelectWrapper {...(wrapperSx && { sx: wrapperSx })}>
      <SelectInput
        options={options}
        value={value}
        onChange={onSearchTypeChange}
        name="searchType"
        control={control}
      />
    </RecallsSearchTypeSelectWrapper>
  );
}
